/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import ActionTypes from '../actions/actionTypes'
import { TablePageData } from '../data/TablePageData'
import { ROUTES } from '../helpers/constants'

const initialState = {
  baseURL: '',
  loginURL: '',
}
const activeMessagingMenu = window.location.pathname.includes(ROUTES.SENT_MESSAGES)
  ? 1
  : window.location.pathname.includes(ROUTES.DRAFT_MESSAGES)
  ? 2
  : window.location.pathname.includes(ROUTES.TRASH_MESSAGES)
  ? 3
  : 0

const uiInitialState = {
  programCourses: { value: 0 },
  registerationState: {
    complete: '',
  },
  transactionFilter: {},
  enrollmentCourseFilter: {},
  paymentTransaction: { value: 0 },
  profileDetails: { activeTab: 0 },
  parentsViewStudentProfileDetails: { activeTab: 0 },
  inboxMessageFilter: {},
  sentMessageFilter: {},
  trashMessageFilter: {},
  draftMessageFilter: {},
  messagingActiveMenu: { activeMenu: activeMessagingMenu },
  enrolledPageDetails: {
    ...TablePageData,
  },
  priorEnrollmentPageDetails: {
    ...TablePageData,
  },
  transactionPageDetails: {
    ...TablePageData,
  },
  walletPageDetails: {
    ...TablePageData,
  },
  programsPageDetails: {
    ...TablePageData,
  },
  inboxMessagePageDetails: {
    ...TablePageData,
  },
  sentMessagePageDetails: {
    ...TablePageData,
  },
  draftMessagePageDetails: {
    ...TablePageData,
  },
  trashMessagePageDetails: {
    ...TablePageData,
  },
}

const enrolledProgram = {
  showLoader: true,
}

const priorProgram = {
  showLoader: true,
  total: 0,
}
const surveyDataArray = { surveys: [] }

export const app = (state = initialState, action) => {
  if (action.type === ActionTypes.APP) {
    return {
      ...state,
      ...action.data,
    }
  } else {
    return state
  }
}

export const uiState = (state = uiInitialState, action = {}) => {
  if (action.type === ActionTypes.UI_STATE) {
    return {
      ...state,
      ...action.data,
    }
  }
  return state
}

export const message = (state = {}, action = {}) => {
  if (action.type === ActionTypes.MESSAGE) {
    return action.data
  }
  return state
}

export const school = (state = {}, action = {}) => {
  if (action.type === ActionTypes.SCHOOL) {
    return action.data
  }
  return state
}

export const introspect = (state = {}, action = {}) => {
  if (action.type === ActionTypes.INTROSPECT) {
    return action.data
  }
  return state
}

export const serviceProvider = (state = '', action = {}) => {
  if (action.type === ActionTypes.SERVICEPROVIDER) {
    return action.data
  }
  return state
}

export const enrolledPrograms = (state = enrolledProgram, action = {}) => {
  if (action.type === ActionTypes.ENROLLED_PROGRAMS) {
    return action.data
  }
  return state
}

export const priorPrograms = (state = priorProgram, action = {}) => {
  if (action.type === ActionTypes.PRIOR_PROGRAMS) {
    return action.data
  }
  return state
}
export const surveyData = (state = surveyDataArray, action = {}) => {
  if (action.type === ActionTypes.SURVEY_DATA) {
    return action.data
  }
  return state
}
